<template>
	<div class="mail-payment-transfer" style="max-width: 580px; background: #ffffff; color: #000000">
		<table border="0" cellpadding="0" cellspacing="0" class="payment-transfer-template" style="width: 100%">
			<tbody>
				<tr>
					<td height="19" align="right" style="padding: 0; color: red; font-size: 13px; font-family: Arial, Helvetica, sans-serif">
						<strong>UNIVERZALNI NALOG ZA PLACANJE</strong>
					</td>
				</tr>
			</tbody>
		</table>
		<table border="0" cellpadding="0" cellspacing="0" style="width: 100%; border: 2px solid red; background: #ffffff; line-height: 1.1">
			<tbody>
				<tr>
					<td width="145" height="80" valign="top" style="font-family: Geneva, Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.2; padding: 0; border-right: 2px solid red; width: 35%; padding: 0; padding-left: 5px">
						<span style="font-family: Arial, Helvetica; font-size: 11px; color: red"><strong>PLATITELJ</strong> (naziv/ime i adresa):</span><br />
						<span style="font-family: Geneva, Arial, Helvetica, sans-serif; font-size: 12px; color: black">
							{{ data.sender?.name }}<br />
							{{ data.sender?.address }}<br />
							{{ data.sender?.city }}
						</span>
					</td>
					<td valign="top" style="padding: 0; background: #fcefe9; width: 65%">
						<table width="100%" border="0" cellspacing="4" cellpadding="0" style="background: #fea78c; border-bottom: 2px solid red; font-size: 11px; line-height: 10px; font-family: Arial, Helvetica, sans-serif">
							<tbody>
								<tr>
									<td height="19" width="9%" style="padding: 0; padding-left: 2px; font-size: 11px; mso-line-height-rule: exactly; line-height: 20px">Hitno</td>
									<td height="19" width="6%" align="center" bgcolor="#FFFFFF" style="padding: 0; mso-line-height-rule: exactly; line-height: 20px"></td>
									<td height="19" width="17%" style="padding: 0; padding-left: 10px; font-size: 11px; mso-line-height-rule: exactly; line-height: 10px">Valuta<br />placanja:</td>
									<td height="19" width="12%" align="center" bgcolor="#FFFFFF" style="padding: 0; mso-line-height-rule: exactly; line-height: 20px">{{ data.currency_code }}</td>
									<td height="19" width="12%" style="padding: 0; padding-left: 10px; font-size: 11px; mso-line-height-rule: exactly; line-height: 20px; height: 20px">Iznos:</td>
									<td height="20" width="44%" align="right" bgcolor="#FFFFFF" style="padding: 0; padding-right: 10px; font-size: 14px; mso-line-height-rule: exactly; line-height: 20px">
										<strong> <BaseUtilsFormatCurrency :price="data.total * data.total_exchange" :show-currency="false" /></strong>
									</td>
								</tr>
							</tbody>
						</table>
						<table width="100%" border="0" cellspacing="4" cellpadding="0" style="border-bottom: 1px solid red; mso-line-height-rule: exactly; line-height: 10px; font-family: Arial, Helvetica, sans-serif">
							<tbody>
								<tr>
									<td height="19" width="32%" style="padding: 0; font-size: 11px; mso-line-height-rule: exactly; line-height: 10px; font-family: Arial, Helvetica, sans-serif; color: red">IBAN ili broj racuna platitelja:</td>
									<td height="19" width="68%" align="center" bgcolor="#FFFFFF" style="padding: 0; border: 1px solid red; mso-line-height-rule: exactly; line-height: 8px">&nbsp;</td>
								</tr>
							</tbody>
						</table>
						<table width="100%" border="0" cellspacing="4" cellpadding="0">
							<tbody>
								<tr>
									<td height="19" width="17%" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 8px">Model</td>
									<td height="19" width="6%" style="padding: 0"></td>
									<td height="19" width="77%" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 8px">Poziv na broj platitelja</td>
								</tr>
								<tr>
									<td height="19" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; padding-left: 10px; border: 1px solid red; line-height: 8px"></td>
									<td height="19" style="padding: 0"></td>
									<td height="19" width="77%" align="center" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; line-height: 8px; border: 1px solid red"></td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
		<table width="100%" border="0" cellpadding="0" cellspacing="4" style="mso-line-height-rule: exactly; line-height: 1.1; border: 2px solid red; border-top: none; border-bottom: none; font-family: Arial, Helvetica, sans-serif" bgcolor="#fcefe9">
			<tbody>
				<tr>
					<td width="160" height="15" style="padding: 0; padding-left: 10px; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red">IBAN ili broj racuna<br />primatelja:</td>
					<td height="8" bgcolor="#FFFFFF" style="padding: 0; padding-left: 5px; border: 1px solid red; font-size: 13px">
						<strong v-if="data?.receive?.bank_number">{{ data.receive?.bank_number }}</strong>
					</td>
				</tr>
			</tbody>
		</table>
		<table width="100%" border="0" cellpadding="0" cellspacing="0" style="border-top: none; border-color: red; border-width: 2px; border-style: solid; background: #ffffff; line-height: 1.1">
			<tbody>
				<tr>
					<td width="145" height="100" valign="top" style="font-family: Geneva, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.2; padding: 0; padding-left: 5px; border-right-width: 1px; border-bottom-width: 1px; width: 35%; color: #000">
						<span style="font-size: 11px; color: red; padding: 0; margin: 0"><strong>PRIMATELJ</strong> (naziv/ime i adresa):</span><br />
						<span style="font-family: Geneva, Arial, Helvetica, sans-serif; font-size: 12px; color: black">
							{{ data.receive?.name }}<br />
							{{ data.receive?.address }}<br />
							{{ data.receive?.city }}
						</span>
					</td>
					<td width="65%" valign="top" style="padding: 0; background: #fcefe9; border-left: 2px solid red; line-height: 1.1">
						<table width="100%" border="0" cellspacing="4" cellpadding="0" style="font-size: 11px; font-family: Arial, Helvetica, sans-serif; border-bottom: 1px solid red">
							<tbody>
								<tr>
									<td height="8" width="17%" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; mso-line-height-rule: exactly; line-height: 8px">Model</td>
									<td height="8" width="6%" style="padding: 0"></td>
									<td height="8" width="77%" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; mso-line-height-rule: exactly; line-height: 8px">Poziv na broj primatelja</td>
								</tr>
								<tr>
									<td height="8" align="center" bgcolor="#FFFFFF" style="padding: 0; border: 1px solid red; line-height: 8px; font-family: Arial, Helvetica, sans-serif">{{ data.receive?.model }}</td>
									<td style="padding: 0; padding-left: 10px"></td>
									<td height="19" width="77%" bgcolor="#FFFFFF" style="padding: 0; padding-left: 10px; border: 1px solid red; line-height: 8px; font-family: Arial, Helvetica, sans-serif">
										{{ data.receive?.reference_number }}
									</td>
								</tr>
							</tbody>
						</table>
						<table width="100%" border="0" cellspacing="4" cellpadding="0" style="font-size: 11px; line-height: 1.1 font-family: Arial, Helvetica, sans-serif">
							<tbody>
								<tr>
									<td height="8" width="24%" valign="bottom" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; mso-line-height-rule: exactly">Sifra namjene:</td>
									<td width="12%" rowspan="2" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; mso-line-height-rule: exactly">Opis placanja:</td>
									<td height="8" width="3%" rowspan="4" style="padding: 0; padding-left: 2px"></td>
									<td height="8" width="61%" rowspan="4" align="center" valign="middle" bgcolor="#FFFFFF" style="padding: 0; font-family: Arial, Helvetica, sans-serif; padding-left: 2px; font-size: 15px; border: 1px solid red">
										{{ data.description }}
									</td>
								</tr>
								<tr>
									<td height="19" bgcolor="#FFFFFF" style="padding: 0; padding-left: 2px; border: 1px solid red; font-family: Arial, Helvetica, sans-serif">{{ data.purpose }}</td>
								</tr>
								<tr>
									<td height="8" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; mso-line-height-rule: exactly">Datum izvrsenja:</td>
									<td height="8" width="12%" style="padding: 0; mso-line-height-rule: exactly"></td>
								</tr>
								<tr>
									<td height="19" colspan="2" bgcolor="#FFFFFF" style="padding: 0; padding-left: 2px; font-family: Arial, Helvetica, sans-serif; border: 1px solid red"></td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>

		<table width="100%" border="0" cellpadding="0" cellspacing="0" style="border-color: red; border-width: 2px; border-style: solid; border-top: none; background: #ffffff">
			<tbody>
				<tr>
					<td width="50%" valign="top" style="padding: 0; border-right-width: 1px; border-bottom-width: 1px; background: #fcefe9">
						<table width="100%" border="0" cellspacing="2" cellpadding="0">
							<tbody>
								<tr>
									<td height="8" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 1.1">BIC i/ili naziv banke primatelja:</td>
									<td height="8" rowspan="2" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 10px; padding-left: 5px">Primatelj<br />(osoba)</td>
									<td height="8" align="center" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 1.1">Fizička</td>
									<td height="8" align="center" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 1.1">Pravna</td>
								</tr>
								<tr>
									<td height="10" bgcolor="#FFFFFF" style="padding: 5px; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; border: 1px solid red">{{ data.receive?.bank_name }}</td>
									<td height="10" align="center" bgcolor="#FFFFFF" style="padding: 5px; border: 1px solid red"></td>
									<td height="10" align="center" bgcolor="#FFFFFF" style="padding: 5px; border: 1px solid red"></td>
								</tr>
								<tr>
									<td height="35" colspan="4" bgcolor="#FFFFFF" style="padding: '10px'; border: 1px solid red; text-align: center">
										<img v-if="data.hub3_url" :src="data.hub3_url" alt="" style="max-height: 40px; max-width: 90%; display: block; margin: auto" />
									</td>
								</tr>
							</tbody>
						</table>
						<table width="100%" border="0" cellspacing="2" cellpadding="0">
							<tbody>
								<tr>
									<td height="8" width="16%" valign="top" style="padding: 0"></td>
									<td height="8" width="17%" valign="top" style="padding: 0"></td>
									<td height="8" width="9%" rowspan="2" valign="top" style="padding: 0"></td>
									<td height="8" width="23%" valign="top" style="padding: 0"></td>
									<td height="6" width="11%" align="center" valign="middle" style="padding: 0; font-size: 10px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 6px">BEN</td>
									<td height="6" width="12%" align="center" valign="middle" style="padding: 0; font-size: 10px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 6px">SHA</td>
									<td height="6" width="12%" align="center" valign="middle" style="padding: 0; font-size: 10px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 6px">OUR</td>
								</tr>
								<tr>
									<td width="16%" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 9px">Valuta<br />pokrica</td>
									<td width="17%" valign="top" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; border: 1px solid red">&nbsp;</td>
									<td width="23%" valign="top" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; line-height: 9px">Troskovna opcija</td>
									<td valign="top" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; border: 1px solid red">&nbsp;</td>
									<td width="12%" valign="top" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; border: 1px solid red">&nbsp;</td>
									<td width="12%" valign="top" bgcolor="#FFFFFF" style="padding: 0; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red; border: 1px solid red">&nbsp;</td>
								</tr>
							</tbody>
						</table>
					</td>
					<td valign="top" style="padding: 0; padding-left: 5px; padding-top: 2px; border-left: 2px solid red; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red">Pecat korisnika PU</td>
					<td valign="top" style="padding: 0; padding-left: 5px; padding-top: 2px; border-left: 1px solid red; font-size: 11px; font-family: Arial, Helvetica, sans-serif; color: red">Potpis korisnika PU</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script setup>
	const props = defineProps({
		data: {
			type: Object,
			required: true,
		},
	});
</script>
